import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/home";
import SignUp from "./pages/SignUp";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import OtpVerification from "./pages/OtpVerification";
import ResetPassword from "./pages/ResetPassword";
import { useTheme } from "./context";
import Startup from "./pages/startup";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import the default styles
import 'simplebar'; // If using JS modules
import 'simplebar/dist/simplebar.css'; // Import styles
import Errorpage from "./pages/errorpage";
import LoadingModal from "./components/Modal";
import Profilepage from "./pages/ProfilePage";
import { InterviewProvider } from "./contexts/interview.context";
import DashboardPage from "./components/dashboard/dashboard.page";
import InterviewsPage from "./pages/InterviewedPositionsListPage";
import LateralLanding from "./pages/homepage";
import InterviewScore from "./pages/InterviewScore";
import PositionInterviewsPage from "./pages/PositionInterviewsPage";
import EndedInterviewScore from "./pages/EndedInterviewScore";
import ContactUsPage from "./pages/ContactUsPage";
import TermsPage from "./pages/terms";

function App() {

  const token = localStorage.getItem('token')
  const { theme } = useTheme();
  useEffect(() => {
    // document.body.style.overflowX = "hidden";
    return () => {
      document.body.style.overflowX = "auto";
    };
  }, []);

  return (
    <div className="font-quicksand min-h-100-vh-safe">
      <ToastContainer theme={theme} />
      <LoadingModal />
      <Router>
        <Routes>
          <Route
            path="/interview-setup"
            element={
              <ProtectedRoute>
                <Startup />
              </ProtectedRoute>
            }
          />
          <Route
            path="/interviews"
            element={
              <ProtectedRoute>
                <InterviewsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/interviews/:positionId"
            element={
              <ProtectedRoute>
                <PositionInterviewsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/interview-scores/:interviewId"
            element={
              <ProtectedRoute>
                <InterviewScore />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ended-interview-score"
            element={
              <ProtectedRoute>
                <EndedInterviewScore />
              </ProtectedRoute>
            }
          />
          <Route
            path="/home"
            element={
              <LateralLanding />
            }
          />
          <Route
            path="/"
            element={<Navigate to={token ? "/interview-setup" : '/home'} replace />}
          />
          <Route
            path="/current-interview"
            element={
              <ProtectedRoute>
                <InterviewProvider>
                  <Home />
                </InterviewProvider>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profilepage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/error"
            element={
              <ProtectedRoute>
                <Errorpage />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/interview-list"
            element={
              <ProtectedRoute>
                <Joblist />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/signup"
            element={
              <PublicRoute>
                <SignUp />
              </PublicRoute>
            }
          />

          <Route path="/contact-us" element={<ContactUsPage />}
          />
          <Route path="/forgot" element={<ForgotPassword />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/otp" element={<OtpVerification />} />
          <Route path="/reset" element={<ResetPassword />} />
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;